import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NamedLink } from '../../components';
import css from './Sidebar.module.css';

const steps = [
  { id: 1, title: 'Business Information', description: 'Company, country, currency' },
  { id: 2, title: 'Contact & Account', description: 'Contact details & password' },
  { id: 3, title: 'Shipping & Billing', description: 'Delivery and invoice addresses' },
  { id: 4, title: 'Agreements', description: 'Accept platform agreements' },
  { id: 5, title: 'Review & Submit', description: 'Review before submitting' },
];

const BuyerSidebar = ({ currentStep, className, rootClassName }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.main}>
        <div className={css.steps}>
          {steps.map((step, index) => {
            const active = currentStep === step.id;
            const completed = currentStep > step.id;
            return (
              <div key={step.id} className={css.step}>
                <div>
                  <div className={classNames(css.circle, { [css.activeCircle]: active, [css.completedCircle]: completed })}>
                    {completed ? '✓' : step.id}
                  </div>
                  {index !== steps.length - 1 && (
                    <div className={classNames(css.line, { [css.activeLine]: completed })} />
                  )}
                </div>
                <div className={classNames(css.card, { [css.activeCard]: active })}>
                  <h4>{step.title}</h4>
                  <p>{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
        <p className={css.loginLink}>
          Already have an account? <NamedLink name="LoginPage">Log in</NamedLink>
        </p>
      </div>
    </div>
  );
};

BuyerSidebar.defaultProps = { className: null, rootClassName: null, currentStep: 1 };
BuyerSidebar.propTypes = { className: PropTypes.string, rootClassName: PropTypes.string, currentStep: PropTypes.number };

export default BuyerSidebar;
